import { useAuth0 } from '@auth0/auth0-react';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { isNullOrUndefined } from '@truescope-web/utils/lib/objects';
import { createAuthenticatedApiLookup, createUnauthenticatedApiLookup } from '../Api';

const ApiLookupContext = createContext({});

/**
 * provides components with the api lookup
 * @param {*} C
 */
export const withApiLookup = (C) => (props) =>
	(
		<ApiLookupContext.Consumer>
			{({ apiLookup }) => {
				return <C apiLookup={apiLookup} {...props} />;
			}}
		</ApiLookupContext.Consumer>
	);

/**
 * alternative way to use the api, without composing the component
 * @returns
 */
export const useApiLookup = () => {
	const context = useContext(ApiLookupContext);
	if (isNullOrUndefined(context)) {
		throw new Error('ApiLookupContext must be used within a ApiLookupProvider');
	}
	return context;
};

/**
 * contains the states for the api lookup
 * @param {*} param0
 */
export const ApiLookupProvider = ({ children }) => {
	const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
	const [apiLookup, setApiLookup] = useState({
		loading: true
	});
	const [headers, setHeaders] = useState({});

	useEffect(() => {
		if (isLoading) {
			return;
		}

		setApiLookup(isAuthenticated ? createAuthenticatedApiLookup(getAccessTokenSilently, headers) : createUnauthenticatedApiLookup());
	}, [isLoading, isAuthenticated, headers]);

	return (
		<ApiLookupContext.Provider
			value={{
				apiLookup,
				headers,
				setHeaders
			}}
		>
			{children}
		</ApiLookupContext.Provider>
	);
};
